<template>
  <div class="tw-w-full tw-flex tw-flex-col">
    <span class="tw-text-base tw-text-textMain tw-font-bold tw-py-3 tw-px-4">{{
      $t("支持与服务")
    }}</span>

    <MobileSelectItem
      v-for="item in supports"
      :key="item.id"
      :item="item"
      @onSelect="handleToDetail"
      :isShowIcon="false"
      :isShowDesc="false"
    />
  </div>
</template>
<script>
import MobileSelectItem from "./components/MobileSelectItem.vue";
import { hideMobileChatBtn } from "@/utils/scriptLoader";
export default {
  name: "MobileSupportMenu",
  components: {
    MobileSelectItem,
  },
  data() {
    return {
      activeId: 1,
      supports: [
        {
          id: 1,
          icon: "/icon-wtfk.png",
          name: this.$t("问题反馈"),
          intro: this.$t("提交问题，快速响应，助您无忧使用"),
        },
        {
          id: 2,
          icon: "/icon-zxkf.png",
          name: this.$t("在线客服"),
          intro: this.$t("实时咨询，解答疑问，助您快速上手"),
        },
      ],
    };
  },
  methods: {
    handleToDetail(item) {
      if (item.id === 1) {
        this.$router.push("/supportAndServices/Feedback");
        this.$emit("handleToDetail", null);
      } else {
        window.kuaizhiMobileChat();
        hideMobileChatBtn();
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
